export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13798.29bb5e8f.jpg";